import { Formik } from "formik";
import moment from "moment";
import { format } from "path";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { onlyNumber } from "../../constant/utils";
import { validatePartner } from "../../constant/validation";
import { dashboardAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import Recaptcha from "../ReCaptcha";

const initialValue = {
  FirstName: "",
  LastName: "",
  Mobile: "",
  EmailId: "",
  CityId: "",
  Address: "",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false,
  GRecaptcha:""
};
const BecomeVendor = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [values, setValues] = useState<any>({ ...initialValue });
  const cityData = useSelector((state: any) => state.dashboard.cityAll);

  useEffect(() => {
    window?.scrollTo(0, 0);
    return () => {};
  }, []);

  const handleSubmit = (value: any) => {
    let data: any = value;
    const urlParams = new URLSearchParams(window.location.search);
    data.UtmSource = urlParams.get("utm_source");
    data.UtmMedium = urlParams.get("utm_medium");
    data.UtmCampaign = urlParams.get("utm_campaign");
  };
  return (
    <>
      <SeoAdd slug={ROUTE.BECOMEVENDOR} />
      <BreadCrumb page={"Vendor"} data={{ slug: "", path: "" }} />
      <section className="about-section">
        <div className="container" id="section2">
          <div className="row">
            <div className="col-md-12">
              <div className="overview-wrap text-center">
                <img
                  src={t("images.partner.banner")}
                  className="scale round_img"
                  alt=""
                />
                <div className="headingmains text-center pb-3">
                  <h1 className="right aos-init mt-sm-4 mt-lg-5">
                    Become A Vendor
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="news_section pb-4">
        <div className="container">
          <div className="row pt-3">
            <div className="col-md-7">
              <div className="partnerDetais w-100">
                <h5>Highlights</h5>
                <ul>
                  <li>
                    Be a part of India’s Leading Super Specialized Laboratory
                    Network.
                  </li>
                  <li>Minimum investment around &#x20B9;2- 3 Lakh.</li>
                  <li>Good return on investment.</li>
                  <li>Exclusive Oncquest collection center.</li>
                </ul>
                <h5>Eligibility</h5>
                <ul>
                  <li>
                    Approx. 150-250 sq. ft. area at ground floor with toilet
                    facility.
                  </li>
                  <li>Preferred from medical experienced background.</li>
                  <li>Good return on investment.</li>
                  <li>A self-motivated entrepreneur.</li>
                </ul>
              </div>
            </div>
            <div className="col-md-5">
              <div className="w-100">
                <div className="h-services">
                  <div className="infobox_wrapper">
                    <Formik
                      initialValues={values}
                      enableReinitialize={true}
                      validationSchema={validatePartner}
                      onSubmit={(val: any) => {
                        handleSubmit(val);
                      }}
                      render={({
                        values,
                        handleChange,
                        errors,
                        touched,
                        handleBlur,
                        handleSubmit,
                        dirty,
                        isValid,
                        setFieldValue
                      }) => (
                        <form onSubmit={handleSubmit}>
                          {/* <h4 className="mr-10">Become A Vendor</h4> */}
                          <h6 className="ln-1 mr-10">
                            INTERESTED? LET'S CONNECT!
                          </h6>
                          <div className="form-group">
                            <input
                              type="text"
                              name="FirstName"
                              className="form-control"
                              placeholder="First Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.FirstName}
                            />
                            {touched?.FirstName && errors?.FirstName && (
                              <span className="error_message">
                                {errors?.FirstName}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              type="text"
                              name="LastName"
                              className="form-control"
                              placeholder="Last Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.LastName}
                            />
                            {touched?.LastName && errors?.LastName && (
                              <span className="error_message">
                                {errors?.LastName}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              type="text"
                              name="Mobile"
                              className="form-control"
                              placeholder="Mobile Number"
                              onKeyPress={onlyNumber}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.Mobile}
                            />
                            {touched?.Mobile && errors?.Mobile && (
                              <span className="error_message">
                                {errors?.Mobile}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              type="text"
                              name="EmailId"
                              className="form-control"
                              placeholder="Email Id"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.EmailId}
                            />
                            {touched?.EmailId && errors?.EmailId && (
                              <span className="error_message">
                                {errors?.EmailId}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <select
                              className="form-control"
                              name="CityId"
                              id="CityId"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.CityId}
                            >
                              <option value="">City</option>
                              {cityData &&
                                cityData.length > 0 &&
                                cityData?.map((item: any, i: any) => (
                                  <option
                                    className="text-uppercase"
                                    value={item?.Id}
                                    key={i}
                                  >
                                    {item?.Name}
                                  </option>
                                ))}
                            </select>
                            {touched?.CityId && errors?.CityId && (
                              <span className="error_message">
                                {errors?.CityId}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              name="Address"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.Address}
                            />
                            {/* {touched?.Address && errors?.Address &&<span className="error_message">{errors?.Address}</span>} */}
                          </div>
                          <div className="d-flex for-check-style">
                            <input
                              type="checkbox"
                              name="Checkbox"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              id="checkbox_id"
                            />
                            <label className="mx-2" htmlFor="checkbox_id">
                              By clicking you accept to the{" "}
                              <a
                                className="text-info"
                                href="https://oncquestlabs.com/terms-condition"
                              >
                                terms and conditions
                              </a>{" "}
                              and the{" "}
                              <a
                                className="text-info"
                                href="https://oncquestlabs.com/privacy-policy"
                              >
                                Privacy Policy.
                              </a>
                            </label>
                          </div>
                          <div>
                            {touched?.Checkbox && errors?.Checkbox && (
                              <span className="error_message">
                                {errors?.Checkbox}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <Recaptcha
                              touch={touched?.GRecaptcha}
                              error={errors?.GRecaptcha}
                              onChange={(token: any) => setFieldValue("GRecaptcha", token)}
                              onExpired={()=> setFieldValue("GRecaptcha", "")}
                            />
                          </div>
                          <button className="book--hexagon active">
                            <span>
                              Submit
                              <i
                                className="fa fa-long-arrow-right ml-20"
                                aria-hidden="true"
                              ></i>
                            </span>
                          </button>
                          <div className="f-10">
                            By continuing, you agree to Oncquest Lab Terms of
                            Use and Privacy Policy.
                          </div>
                        </form>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BecomeVendor;
